module.exports = __webpack_public_path__ + "static/pay-amex-444731bb952da316654e8732f06dfaff.svg";